import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";

const TermSchema = () => Yup.object().shape({
  code: Yup
    .string()
    .label("ID")
    .required()
    ,
  name: Yup
    .string()
    .label("Term")
    .required()
    ,
  status: Yup
    .string()
    .label("Status")
    .required()
    .oneOf(Object.values(STATUS)),
});

export default TermSchema
